import { defineComponent as _defineComponent } from 'vue'
import { mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLink, mdiTwitter, mdiYoutube } from '@mdi/js'
import { Studio } from '@/modules/Studios/types'
import { useImage } from '@/shared/composables/image'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioHeader',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio
};



const { getStudioImage } = useImage()
const hasSocials = computed(() => {
  return Object.values(props.studio.socials).some((value) => value)
})

return { __sfc: true,props, getStudioImage, hasSocials, mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLink, mdiTwitter, mdiYoutube }
}

})